angular.module('impactx.search').controller('SearchCtrl', [
    '$scope',
    'searchFilter',
    '$redirect',
    '$context',
    'TranslationService',
    'sidebarShow',
    '$location',
    'SearchFilter',
    '$routeParams',
    'SearchFilterStorage',
    'AppConfiguration',
    SearchCtrl
]);

function SearchCtrl($scope, searchFilter, $redirect, $context, TranslationService, sidebarShow, $location, SearchFilter, $routeParams, SearchFilterStorage, AppConfiguration) {
    var ctrl = this;
    this.focused = false;
    ctrl.sidebarShow = sidebarShow;
    $scope.searchFilter = searchFilter;
    $scope.showSearch = $context.showSearch.value;

    $scope.$watch(function () {
        return $context.showSearch.value;
    }, function (newVal) {
        $scope.showSearch = newVal;
        $scope.searchPlaceHolder = TranslationService.get('searchPlaceHolder');
    });

    ctrl.search = function (item) {
        if ($scope.global) {
            searchFilter.searchInput = searchFilter.searchInputGlobal;
        }
        ctrl.closeSuggestions();

        // checking searchFilter.searchInput prevents the broadcast on the "empty" search after redirect to lot or supplier
        if (AppConfiguration.get('CollapseInfoHeaderOnSearch') &&
            (!item || !(item.isSupplier || item.isLot)) &&
            searchFilter.searchInput) {
            $scope.$broadcast('MainSearchTriggered');
        }
        $scope.transferSupplier = SearchFilter.getSupplier();

        SearchFilter.setFilters(SearchFilterStorage.getFreshFilter());

        if ($location.path().indexOf("/vcatalog/") > -1 && !$scope.global) {
            SearchFilter.getFilters().vcatalogId = {value: $routeParams.id};
            SearchFilter.getFilters().dialogFilter = "vcat";
            SearchFilterStorage.setVCatFilter($routeParams.id, SearchFilter.getFilters());
        }
        else if ($location.path().indexOf("/tender/") > -1 && !$scope.global) {
            SearchFilter.getFilters().tenderId = {value: $routeParams.id};
            SearchFilter.getFilters().dialogFilter = "tender";
            SearchFilterStorage.setTenderFilter($routeParams.id, SearchFilter.getFilters());
        }
        else if ($location.path().indexOf("/lot/") > -1 && !$scope.global) {
            SearchFilter.getFilters().lotId = {value: $routeParams.id};
            SearchFilter.getFilters().dialogFilter = "lot";
            SearchFilterStorage.setLotFilter($routeParams.id, SearchFilter.getFilters());
        }
        else if ($location.path().indexOf("/supplier/") > -1 && !$scope.global) {
            SearchFilter.getFilters().supplierId = {value: $routeParams.id};
            SearchFilter.getFilters().dialogFilter = "supplier";
            SearchFilterStorage.setSupplierFilter($routeParams.id, SearchFilter.getFilters());
        }
        else if ($location.path().indexOf("/manufacturer/") > -1 && !$scope.global) {
            SearchFilter.getFilters().manufacturerId = {value: $routeParams.id};
            SearchFilter.getFilters().dialogFilter = "manufacturer";
            SearchFilterStorage.setManufacturerFilter($routeParams.id, SearchFilter.getFilters());
        }
        else {
        }

        if ($scope.transferGuidingClassification) {
            SearchFilter.setGuidingClassification($scope.transferGuidingClassification);
        }

        if ($scope.transferSupplier) {
            SearchFilter.setSupplier($scope.transferSupplier);
        }

        if (item) {
            if (item.isClassification) {
                searchFilter.searchInput = "";
                searchFilter.searchInputGlobal = "";
                var guidingClassification = {id: item.id, value: item.value};
                SearchFilter.setGuidingClassification(guidingClassification);
                SearchFilter.setSearchInputClassification(guidingClassification);
            }
            else if (item.isSupplier) {
                searchFilter.searchInput = "";
                searchFilter.searchInputGlobal = "";
                SearchFilter.setSupplier({id: item.id, value: item.value});
            }
            else if (item.isLot) {
                searchFilter.searchInput = "";
                searchFilter.searchInputGlobal = "";
                SearchFilter.setLotId(item.id);
            }
        }

        if (SearchFilter.getFilterIdentifier() === 'search') {
            searchFilter.resetDetailFilter().then(function () {
                var filterData = {};
                if ($context.hasActiveShopView.value) {
                    searchFilter.listSearch.value = true;
                }
                if (impactX.isDefined(item, 'isSupplier')) {
                    filterData = SearchFilter.getFilters();
                    if (impactX.isDefined(filterData, "supplier.selected.id")) {
                        $redirect.redirectTo(null, "/supplier/" + filterData.supplier.selected.id + ($routeParams.useSetFilter ? ("/" + $routeParams.useSetFilter) : ""));
                    }

                }
                else if (impactX.isDefined(item, 'isLot')) {
                    filterData = SearchFilter.getFilters();
                    if (impactX.isDefined(filterData, "lotId.value")) {
                        $redirect.redirectTo(null, "/lot/" + filterData.lotId.value + ($routeParams.useSetFilter ? ("/" + $routeParams.useSetFilter) : ""));
                    }
                }
                else {
                    SearchFilter.getFilters().searchInput.value = searchFilter.searchInput;
                    if ($location.path().indexOf("/vcatalog/") > -1 && !$scope.global) {
                        SearchFilter.getFilters().searchInputUsed = true;
                        if ($scope.searchFunction) {
                            $scope.searchFunction({item: item});
                        }
                        else if ($routeParams.useSetFilter) {
                            var prgId = $routeParams.prgId ? $routeParams.prgId : 0;
                            $redirect.redirectTo(null, "/vcatalog/" + $routeParams.id + "/" + prgId + "/" + $routeParams.useSetFilter);
                        }
                        else {
                            $redirect.redirectTo(null, "/vcatalog/" + $routeParams.id + ($routeParams.prgId ? ("/" + $routeParams.prgId) : ""));
                        }
                    }
                    else if ($context.hasActiveShopView.value) {
                        var storedSearchFilterObject = SearchFilterStorage.getVCatFilter($context.hasActiveShopView.id);
                        if (storedSearchFilterObject) {
                            storedSearchFilterObject.searchInput.value = searchFilter.searchInput;
                            storedSearchFilterObject.searchInputUsed = true;
                        }
                        else {
                            SearchFilter.getFilters().searchInputUsed = true;
                        }
                        $redirect.redirectTo(null, "/vcatalog/" + $context.hasActiveShopView.id);
                    }
                    else if ($location.path().indexOf("/tender/") > -1 && !$scope.global) {
                        SearchFilter.getFilters().searchInputUsed = true;
                        if ($scope.searchFunction) {
                            $scope.searchFunction({item: item});
                        }
                        else {
                            $redirect.redirectTo(null, "/tender/" + $routeParams.id + ($routeParams.useSetFilter ? ("/" + $routeParams.useSetFilter) : ""));
                        }
                    }
                    else if ($location.path().indexOf("/lot/") > -1 && !$scope.global) {
                        SearchFilter.getFilters().searchInputUsed = true;
                        if ($scope.searchFunction) {
                            $scope.searchFunction({item: item});
                        }
                        else {
                            $redirect.redirectTo(null, "/lot/" + $routeParams.id + ($routeParams.useSetFilter ? ("/" + $routeParams.useSetFilter) : ""));
                        }
                    }
                    else if ($location.path().indexOf("/supplier/") > -1 && !$scope.global) {
                        SearchFilter.getFilters().searchInputUsed = true;
                        if ($scope.searchFunction) {
                            $scope.searchFunction({item: item});
                        }
                        else {
                            $redirect.redirectTo(null, "/supplier/" + $routeParams.id + ($routeParams.useSetFilter ? ("/" + $routeParams.useSetFilter) : ""));
                        }
                    }
                    else if ($location.path().indexOf("/manufacturer/") > -1 && !$scope.global) {
                        SearchFilter.getFilters().searchInputUsed = true;
                        if ($scope.searchFunction) {
                            $scope.searchFunction({item: item});
                        }
                        else {
                            $redirect.redirectTo(null, "/manufacturer/" + $routeParams.id + ($routeParams.useSetFilter ? ("/" + $routeParams.useSetFilter) : ""));
                        }
                    }
                    else {
                        if ($location.path().indexOf("/search.") > -1) {
                            SearchFilter.getFilters().searchInputUsed = true;
                        }
                        $redirect.redirectTo(null, "/search");
                    }
                }
            });
        }

    };

    function redirectToDialogOrList() {
        $redirect.redirectTo(null, "/search");
    }

    this.closeSuggestions = function () {
        // for some reason blur() in the input isn't enough to close the suggestions properly.
        // if you do so the suggestion box will be hidden but it messes up the size of the suggestion box if you open it again.
        // so at first we hide the suggestion box through the autocomplete controller
        var mainSearchElement = angular.element(document.getElementById('mainSearchAC'));
        var autocompleteController = mainSearchElement.controller('mdAutocomplete');
        if (autocompleteController) {
            autocompleteController.hidden = true;
        }

        // and now we can remove the focus from the input to make sure the user can focus the input again
        angular.element('#mainSearch').blur();
    };
}
